import { local } from "./local";
import Cookies from "js-cookie";
import { clientData } from "$lib/client-data/index.svelte.js";

/**
 * 用户列表KEY
 */
const USERS_KEY = "users";

/**
 * 获取当前用户的缓存数据。
 * @returns {any} 当前用户的缓存数据，如果不存在则返回 undefined。
 */
export function getUserCache(key, defaultVal) {
  const memberId = local?.user?.memberId;
  if (!memberId) return undefined;
  let users = local[USERS_KEY];
  if (!users) {
    users = {};
    local[USERS_KEY] = users;
  }
  let user = users[memberId];
  if (!user) {
    user = {};
    users[memberId] = user;
    local[USERS_KEY] = users;
  }
  if (!user[key] && defaultVal) {
    users[memberId][key] = defaultVal;
    local[USERS_KEY] = users;
  }
  return users[memberId][key];
}

/**
 * 设置当前用户的缓存数据。
 * @param {any} data 要缓存的数据。
 */
export function setUserCache(key, data) {
  const memberId = local?.user?.memberId;
  if (!memberId) return;
  let users = local[USERS_KEY];
  if (!users) {
    local[USERS_KEY] = {};
    users = {};
  }
  if (!users[memberId]) {
    users[memberId] = {};
  }
  users[memberId][key] = data;
  local[USERS_KEY] = users;
}

/**
 * 获取用户token ，已登录的用户
 * @returns {string|undefined}
 */
export const getUserToken = () => {
  return Cookies.get("token");
};

/**
 * 用户token
 * @returns {string}
 */
export const getToken = () => {
  let token = getUserToken() || clientData.auth?.token || "";
  return token;
};

/**
 * 删除token
 */
export const removeToken = () => {
  Cookies.remove("token");
};

/**
 * 清理用户缓存（退出登录时调用）
 */
export const clearUser = () => {
  local.user = null;
  local.thirdGame = null;
  local.appMember = null;
  clientData.auth = null;
  clientData.my = {};
  if (!clientData.notice) clientData.notice = {};
  clientData.notice.stationLetterList = [];
  clientData.notice.announcementList = [];
  removeToken();
};
